import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, makeStyles, Container, CardHeader, Button, CardContent, Typography, Divider, MenuItem, Grid, InputLabel, TextField, TableCell, TableRow, TableContainer, TableBody, Table, Paper, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import services from '../Services';
import { useNavigate, useParams } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import { LoadingComponent } from '../../../utils/newLoader';
import { Formik } from 'formik';
import * as Yup from "yup";
import { useAlert } from "react-alert";
import tokenDecoder from '../../../utils/tokenDecoder';
import ReactToPrint from 'react-to-print';
import CreatePDF from './CreatePDF';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { format } from 'date-fns';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  table: {
    minWidth: 550,
  },
  tableContainer: {
    border: '2px solid #424242',
    borderRadius: '5px',
    padding: theme.spacing(2),

  },
  table: {
    minWidth: 550,
    borderCollapse: 'collapse',
  },
  tableCell: {
    border: '1px solid #424242',
    paddingLeft: '15px',
    paddingRight: '15px',
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },
}));

const screenCode = 'PURCHASEORDERAPPROVAL';
export default function PurchaseOrderApproval() {
  const classes = useStyles();
  const navigate = useNavigate();
  const alert = useAlert();
  const [title, setTitle] = useState("Approve Purchase Order");
  const { purchaseOrderID } = useParams();
  const { groupID } = useParams();
  const { factoryID } = useParams();
  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [openDialogForReject, setOpenDialogForReject] = useState(false);
  const [openDialogForApprove, setOpenDialogForApprove] = useState(false);
  const [quotations, setQuotations] = useState([]);
  const [backConfirmation, setBackConfirmation] = useState(false);
  const [supplliers, setSuppliers] = useState([]);
  const componentRef = useRef();
  const [purchaseOrderDetails, setPurchaseOrderDetails] = useState({
    groupID: 0,
    factoryID: 0,
    supplierID: 0,
    quotationHeaderID: 0
  });
  const [supplierDetails, setSupplierDetails] = useState({});
  const [quotationDetails, setQuotationDetails] = useState([]);
  const [selectedPurchaseOrders, setSelectedPurchaseOrders] = useState([]);
  const [selectedDueDate, handleDueDateChange] = useState(new Date());
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isApproveEnabled: false,
  });

  let decrypted = 0;
  let decryptedfactoryID = 0;
  let decryptedgroupID = 0

  useEffect(() => {
    trackPromise(getPermissions(),
    );
  }, []);

  useEffect(() => {
    decrypted = atob(purchaseOrderID.toString());
    decryptedgroupID = atob(groupID.toString());
    decryptedfactoryID = atob(factoryID.toString());
    if (decrypted != 0) {
      trackPromise(GetPurchaseOrderDetails(decrypted, decryptedgroupID, decryptedfactoryID), getGroupsForDropdown(), getFactoryByGroupID(decryptedgroupID));
    }
  }, []);

  useEffect(() => {
    if (purchaseOrderDetails.groupID > 0) {
      trackPromise(getFactoryByGroupID(purchaseOrderDetails.groupID),);
    };
  }, [purchaseOrderDetails.groupID]);

  useEffect(() => {
    if (purchaseOrderDetails.factoryID > 0) {
      trackPromise(GetSuppliersForDropDown());
    };
  }, [purchaseOrderDetails.groupID, purchaseOrderDetails.factoryID]);

  useEffect(() => {
    if (purchaseOrderDetails.supplierID > 0) {
      trackPromise(GetQuotationBySupplierID());
    };
  }, [purchaseOrderDetails.supplierID]);

  async function getPermissions(IDdata) {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'APPROVEPURCHASEORDER');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
    var isApproveEnabled = permissions.find(p => p.permissionCode == 'PURCHASEORDERAPPROVEBUTTONENABLED');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
      isApproveEnabled: isApproveEnabled !== undefined,
    });
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }

  async function getFactoryByGroupID(groupID) {
    var response = await services.getFactoryByGroupID(groupID);
    setFactories(response);
  };

  async function GetSuppliersForDropDown() {
    const supplliers = await services.GetSuppliersByItemIDAndFactoryID(purchaseOrderDetails.groupID, purchaseOrderDetails.factoryID);
    const formattedSuppliers = supplliers.map((supplier, index) => ({
      supplierID: index,
      supplierName: supplier
    }));
    setSuppliers(formattedSuppliers);
  }

  async function GetQuotationBySupplierID() {
    const quotations = await services.GetQuotationBySupplierID(purchaseOrderDetails.supplierID);
    setQuotations(quotations);
  }

  async function GetPurchaseOrderDetails(purchaseOrderID, groupID, factoryID) {
    let response = await services.GetPurchaseOrderDetails(purchaseOrderID, groupID, factoryID);
    setSupplierDetails(response.supplierDetails);
    setQuotationDetails(response.skuDetails);
    setTitle("Approve PurchaseOrder");
    setPurchaseOrderDetails((PrevState) => ({
      ...PrevState,
      groupID: response.supplierDetails.groupID,
      factoryID: response.supplierDetails.factoryID,
      supplierID: response.supplierDetails.supplierID,
      quotationHeaderID: response.supplierDetails.quotationHeaderID,
    }));

    setSelectedPurchaseOrders((prevOrders) => [
      ...prevOrders,
      { purchaseOrderID, status: 1 }
    ]);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setPurchaseOrderDetails({
      ...purchaseOrderDetails,
      [e.target.name]: value
    });
  }

  function handleSearchDropdownChangeBuyer(event, value) {
    if (value) {
      setPurchaseOrderDetails((prevState) => ({
        ...purchaseOrderDetails,
        supplierID: value.supplierID,
        supplierName: value.supplierName,
      }));
    }
  }

  async function ApprovePurchaseOrder(updatedOrders) {

    if (selectedPurchaseOrders.length <= 0) {
      alert.error('Please select Purchase orders');
    }
    else {
      let saveModel = {
        groupID: parseInt(purchaseOrderDetails.groupID),
        factoryID: parseInt(purchaseOrderDetails.factoryID),
        modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),
        modifiedDate: new Date().toISOString(),
        poitemList: updatedOrders
      }

      let response = await services.ApprovePurchaseOrders(saveModel);
      if (response.statusCode == "Success") {
        alert.success(response.message);
        setSelectedPurchaseOrders([]);
        navigate('/app/purchaseOrderApproval/listing');
      }
      else {
        alert.error(response.message);
      }
    }
  }

  function handleDialogOpenForReject() {
    setOpenDialogForReject(true)
  }
  function handleDialogOpenForAccept() {
    setOpenDialogForApprove(true)
  }
  function handleDialogCloseForReject() {
    setOpenDialogForReject(false)
  }

  function handleDialogCloseForApprove() {
    setOpenDialogForApprove(false)
  }

  const handleApprove = () => {
    let updatedOrders = selectedPurchaseOrders.map((order) => ({
      purchaseOrderID: order.purchaseOrderID,
      status: 2,
    }));

    setSelectedPurchaseOrders(updatedOrders);

    return trackPromise(ApprovePurchaseOrder(updatedOrders));
  };

  const handleReject = () => {
    let updatedOrders = selectedPurchaseOrders.map((order) => ({
      purchaseOrderID: order.purchaseOrderID,
      status: 3,
    }));

    setSelectedPurchaseOrders(updatedOrders);

    return trackPromise(ApprovePurchaseOrder(updatedOrders));
  };

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={handleConfirmBackOne}
          />
        </Grid>
      </Grid>
    )
  }

  function handleConfirmBack() {
    setBackConfirmation(false)
  }

  function handleConfirmBackOpen() {
    setBackConfirmation(true)
  }

  function handleConfirmBackOne() {
    if (supplierDetails.length != 0) {
      handleConfirmBackOpen()
    }
    else {
      handleClick()
    }
  }

  const handleClick = () => {
    navigate('/app/purchaseOrderApproval/listing');
  }

  const handleConfirmBackTwo = () => {
    setBackConfirmation(false);
    navigate('/app/purchaseOrderApproval/listing');
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page
        className={classes.root}
        title={title}
      >
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: purchaseOrderDetails.groupID,
              factoryID: purchaseOrderDetails.factoryID,
              supplierID: purchaseOrderDetails.supplierID,
              quotationHeaderID: purchaseOrderDetails.quotationHeaderID,
            }}

            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
              })
            }
            onSubmit={GetPurchaseOrderDetails}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched,
              setFieldValue
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent style={{ marginBottom: "2rem" }}>
                        <Grid container spacing={3}>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group  *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              helperText={touched.groupID && errors.groupID}
                              fullWidth
                              name="groupID"
                              onChange={(e) => handleChange(e)}
                              value={purchaseOrderDetails.groupID}
                              variant="outlined"
                              size="small"
                              onBlur={handleBlur}
                              InputProps={{
                                readOnly: true,
                              }}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={purchaseOrderDetails.factoryID}
                              variant="outlined"
                              id="factoryID"
                              size='small'
                              InputProps={{
                                readOnly: true,
                              }}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="supplierID">
                              Supplier *
                            </InputLabel>
                            <Autocomplete
                              id="supplierID"
                              options={supplliers || []}
                              size="small"
                              clearOnBlur={false}
                              getOptionLabel={(option) => option?.supplierName || ''}
                              onChange={(event, value) => {
                                setFieldValue('supplierID', value ? value.supplierID : '');
                                handleSearchDropdownChangeBuyer(event, value);
                              }}
                              value={
                                (supplliers && supplliers.find((supplier) => supplier?.supplierID === purchaseOrderDetails.supplierID)) || null
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  error={Boolean(touched.supplierID && errors.supplierID)}
                                  helperText={touched.supplierID && errors.supplierID}
                                  variant="outlined"
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                  placeholder="--Select Supplier--"
                                />
                              )}
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="quotationHeaderID">
                              Quotation Number *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.quotationHeaderID && errors.quotationHeaderID)}
                              fullWidth
                              helperText={touched.quotationHeaderID && errors.quotationHeaderID}
                              size='small'
                              name="quotationHeaderID"
                              onChange={(e) => {
                                handleChange(e)
                              }}
                              value={purchaseOrderDetails.quotationHeaderID}
                              variant="outlined"
                              id="quotationHeaderID"
                              InputProps={{
                                readOnly: true,
                              }}
                            >
                              <MenuItem value="0">--Select Quotation Number --</MenuItem>
                              {generateDropDownMenu(quotations)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink>
                              Delivery Date *
                            </InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                id="date-picker-inline"
                                disabled="true"
                                value={supplierDetails?.dateOfDelivery ? new Date(supplierDetails.dateOfDelivery) : null}
                                onChange={(e) => {
                                  handleDueDateChange(e)
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                inputProps={{
                                  readOnly: true
                                }}
                                size='small'
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                      </CardContent>
                      {(supplierDetails.length > 0 || quotationDetails.length > 0) ? (
                        <>
                          <hr style={{ border: "1px solid black" }} />
                          <Typography variant="h5" style={{ marginLeft: '10px', fontWeight: 'bold', textAlign: "right", marginRight: "10px" }}>
                            Purchase Order : {supplierDetails?.purchaseOrderNumber} &nbsp;&nbsp;&nbsp; Delivery Date :
                            {supplierDetails?.dateOfDelivery ? format(new Date(supplierDetails.dateOfDelivery), "yyyy-MM-dd") : "-"}
                          </Typography>
                          <hr style={{ border: "1px solid black" }} />
                          <Grid container spacing={2} style={{ marginTop: 20 }}>
                            <Grid item xs={6}>
                              <TableContainer component={Paper}>
                                <Table size="small">
                                  <TableBody>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}><b>Supplier Name</b></TableCell>
                                      <TableCell style={{ border: "1px solid black" }}>{supplierDetails?.supplierName || "-"}</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}><b>Address</b></TableCell>
                                      <TableCell style={{ border: "1px solid black" }}>{supplierDetails?.supplierAddress || "-"}</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}><b>Tel No.</b></TableCell>
                                      <TableCell style={{ border: "1px solid black" }}>{supplierDetails?.contactNumber || "-"}</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}><b>Supplier VAT No.</b></TableCell>
                                      <TableCell style={{ border: "1px solid black" }}>{supplierDetails?.supplierVATNo || "-"}</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}><b>Supplier SVAT No.</b></TableCell>
                                      <TableCell style={{ border: "1px solid black" }}>{supplierDetails?.supplierSVATNo || "-"}</TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Grid>
                            <Grid item xs={6}>
                              <TableContainer component={Paper}>
                                <Table size="small">
                                  <TableBody style={{ border: "1px solid black" }}>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}><b>Date</b></TableCell>
                                      <TableCell style={{ border: "1px solid black" }}> {supplierDetails?.orderDate ? format(new Date(supplierDetails.orderDate), "yyyy-MM-dd") : "-"}</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}><b>Factory Name</b></TableCell>
                                      <TableCell style={{ border: "1px solid black" }}>{supplierDetails.factoryName || "-"}</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}><b>Req. No</b></TableCell>
                                      <TableCell style={{ border: "1px solid black" }}>
                                        <ul style={{ margin: 0, paddingLeft: "20px" }}>
                                          {[...new Set(quotationDetails.map(item => item.requisitionNumber))].map((reqNum, index) => (
                                            <li key={index}>{reqNum}</li>
                                          ))}
                                        </ul>
                                      </TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}><b>Company VAT No</b></TableCell>
                                      <TableCell style={{ border: "1px solid black" }}>{supplierDetails.companyVATNo || "-"}</TableCell>
                                    </TableRow>
                                    <TableRow style={{ border: "1px solid black" }}>
                                      <TableCell style={{ border: "1px solid black" }}><b>Company SVAT No</b></TableCell>
                                      <TableCell style={{ border: "1px solid black" }}>{supplierDetails.companySVATNo || "-"}</TableCell>
                                    </TableRow>
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Grid>
                          </Grid>
                        </>
                      ) : null}
                      {(supplierDetails.length > 0 || quotationDetails.length > 0) ? (
                        <Grid>
                          <TableContainer component={Paper} style={{ marginTop: 30 }}>
                            <Table size="small" style={{ border: "1px solid black" }}>
                              <TableBody style={{ border: "1px solid black" }}>
                                <TableRow style={{ border: "1px solid black" }}>
                                  <TableCell style={{ border: "1px solid black" }}><b>Item Code</b></TableCell>
                                  <TableCell style={{ border: "1px solid black" }}><b>Description</b></TableCell>
                                  <TableCell style={{ border: "1px solid black" }}><b>Unit</b></TableCell>
                                  <TableCell style={{ border: "1px solid black" }}><b>Quantity</b></TableCell>
                                  <TableCell style={{ border: "1px solid black", textAlign: "center" }}><b>Unit Price</b></TableCell>
                                  <TableCell style={{ border: "1px solid black", textAlign: "center" }}><b>Total</b></TableCell>
                                </TableRow>
                                {quotationDetails.length > 0 ? quotationDetails.map((item, index) => (
                                  <TableRow key={index} style={{ border: "1px solid black" }}>
                                    <TableCell style={{ border: "1px solid black" }}>{item.itemCode || "-"}</TableCell>
                                    <TableCell style={{ border: "1px solid black" }}>{item.skuMasterName || "-"}</TableCell>
                                    <TableCell style={{ border: "1px solid black" }}>{item.unit || "-"}</TableCell>
                                    <TableCell style={{ border: "1px solid black" }}>{Number(item.quantity).toLocaleString("en-US") || "-"}</TableCell>
                                    <TableCell style={{ border: "1px solid black" }} align="right">{Number(item.unitPrice).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || "-"}</TableCell>
                                    <TableCell style={{ border: "1px solid black" }} align="right">{Number(item.totalPrice).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || "-"}</TableCell>
                                  </TableRow>
                                )) : <TableRow style={{ border: "1px solid black" }}><TableCell colSpan={6} align="center">No items available</TableCell></TableRow>}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                      ) : null}
                      <Box display="flex" flexDirection="column">
                        {(supplierDetails.length > 0 || quotationDetails.length > 0) ? (
                          <Grid>
                            <TableContainer component={Paper} style={{ marginTop: 20, width: "50%", float: "right" }}>
                              <Table size="small" style={{ border: "1px solid black" }}>
                                <TableBody>
                                  <TableRow style={{ border: "1px solid black" }}>
                                    <TableCell style={{ border: "1px solid black" }}><b>Gross Amount</b></TableCell>
                                    <TableCell style={{ border: "1px solid black" }} align="right">{Number(supplierDetails?.grossAmount).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || "0.00"}</TableCell>
                                  </TableRow>
                                  <TableRow style={{ border: "1px solid black" }}>
                                    <TableCell style={{ border: "1px solid black" }}><b>Discount</b></TableCell>
                                    <TableCell style={{ border: "1px solid black" }} align="right">{Number(supplierDetails?.discountAmount).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || "0.00"}</TableCell>
                                  </TableRow>
                                  <TableRow style={{ border: "1px solid black" }}>
                                    <TableCell style={{ border: "1px solid black" }}><b>SVAT/VAT</b></TableCell>
                                    <TableCell style={{ border: "1px solid black" }} align="right">{supplierDetails?.vat || "0.00"}</TableCell>
                                  </TableRow>
                                  <TableRow style={{ border: "1px solid black" }}>
                                    <TableCell style={{ border: "1px solid black" }}><b>Net Amount</b></TableCell>
                                    <TableCell style={{ border: "1px solid black" }} align="right">{Number(supplierDetails?.netAmount).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || "0.00"}</TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Grid>
                        ) : null}
                        {quotationDetails.length > 0 || supplierDetails.length > 0 ? (
                          <Box display="flex" justifyContent="flex-end" p={4}>
                            <ReactToPrint
                              documentTitle={"Purchase Order"}
                              trigger={() => <Button
                                color="primary"
                                id="btnCancel"
                                variant="contained"
                                style={{ marginTop: '2rem', marginBottom: '2rem', marginRight: '1rem' }}
                              >
                                PDF
                              </Button>}
                              content={() => componentRef.current}
                            />
                            <div hidden={true}>
                              <CreatePDF ref={componentRef}
                                quotationDetails={quotationDetails} supplierDetails={supplierDetails}
                                purchaseOrderDetails={purchaseOrderDetails}
                              />
                            </div>
                            <Button
                              color="primary"
                              disabled={supplierDetails.status != 1 || !permissionList.isApproveEnabled}
                              type="submit"
                              variant="contained"
                              className={classes.colorCancel}
                              onClick={() => {
                                handleDialogOpenForReject();
                              }}
                              style={{ marginTop: '2rem', marginBottom: '2rem', marginRight: '1rem' }}
                            >
                              Reject
                            </Button>
                            <Button
                              color="primary"
                              disabled={supplierDetails.status != 1 || !permissionList.isApproveEnabled}
                              type="submit"
                              variant="contained"
                              className={classes.colorRecord}
                              onClick={() => {
                                handleDialogOpenForAccept();
                              }}
                              style={{ marginTop: '2rem', marginBottom: '2rem', marginRight: '1rem' }}
                            >
                              Approve
                            </Button>
                            <Dialog open={openDialogForReject} onClose={handleDialogCloseForReject}>
                              <DialogTitle>Confirm To Reject</DialogTitle>
                              <DialogContent>
                                <DialogContentText>Are you sure you want to reject this?</DialogContentText>
                              </DialogContent>
                              <DialogActions className={classes.dialogActions}>
                                <Button onClick={handleReject} color="primary" autoFocus>
                                  Yes
                                </Button>
                                <Button onClick={handleDialogCloseForReject} color="primary">
                                  No
                                </Button>
                              </DialogActions>
                            </Dialog>
                            <Dialog open={openDialogForApprove} onClose={handleDialogCloseForApprove}>
                              <DialogTitle>Confirm To Approve</DialogTitle>
                              <DialogContent>
                                <DialogContentText>Are you sure you want to approve this?</DialogContentText>
                              </DialogContent>
                              <DialogActions className={classes.dialogActions}>
                                <Button onClick={handleApprove} color="primary" autoFocus>
                                  Yes
                                </Button>
                                <Button onClick={handleDialogCloseForApprove} color="primary">
                                  No
                                </Button>
                              </DialogActions>
                            </Dialog>

                          </Box>
                        ) : null}
                      </Box>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
        <Dialog open={backConfirmation}>
          <DialogTitle id="alert-dialog-slide-title">
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h3">
              <Box textAlign="center">
                Confirmation
              </Box>
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <Typography variant="h5">Are you sure you want to go back?</Typography>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <br />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleConfirmBackTwo} color="primary">
              Yes
            </Button>
            <Button
              onClick={handleConfirmBack} color="primary" autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>
      </Page >
    </Fragment >
  )
}
